Array.prototype.pushEachElement = function (otherArray) {
  for (let i = 0, len = otherArray.length; i < len; i++) {
    this.push(otherArray[i]);
  }
};
Array.prototype.pushIfNotIncluded = function (el) {
  if (!this.includes(el)) {
    this.push(el);
  }
};
Array.prototype.removeIfIncluded = function (el) {
  if (this.includes(el)) {
    let indexOfElementToRemove = this.indexOf(el);

    this.splice(indexOfElementToRemove, 1);
  }
};
Array.prototype.last = function () {
  return this[this.length - 1];
};
Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};
Array.prototype.getElementsUpToAndIncluding = function (el) {
  let index = this.indexOf(el);

  if (index < 0) {
    return [];
  }

  return this.slice(0, index);
};
Number.prototype.roundToNearestFive = function () {
  let decimalPointIndex;
  let onesPlaceAndToTheRight;
  let toTheLeftOfOnesPlace;
  let returnValue;
  let number;

  number = this.toString();
  decimalPointIndex = number.indexOf('.');

  if (decimalPointIndex === -1) {
    decimalPointIndex = number.length;
  }
  onesPlaceAndToTheRight = number.substring(decimalPointIndex - 1);
  onesPlaceAndToTheRight = Number(onesPlaceAndToTheRight);
  toTheLeftOfOnesPlace = number.substring(0, decimalPointIndex - 1);

  if (onesPlaceAndToTheRight >= 0 && onesPlaceAndToTheRight < 2.5) {
    toTheLeftOfOnesPlace += '0';
    returnValue = Number(toTheLeftOfOnesPlace);
  } else if (onesPlaceAndToTheRight >= 2.5 && onesPlaceAndToTheRight < 7.5) {
    toTheLeftOfOnesPlace += '5';
    returnValue = Number(toTheLeftOfOnesPlace);
  } else if (onesPlaceAndToTheRight >= 7.5) {
    toTheLeftOfOnesPlace += '0';
    toTheLeftOfOnesPlace = Number(toTheLeftOfOnesPlace);
    toTheLeftOfOnesPlace += 10;
    returnValue = toTheLeftOfOnesPlace;
  } else {
    throw new Error('Invalid value for onesPlaceAndToTheRight: ', onesPlaceAndToTheRight);
  }

  return returnValue;
};
Number.prototype.roundToOneDecimalPlace = function () {
  return Number(this.toFixed(1));
};
Number.prototype.roundToTwoDecimalPlaces = function () {
  return Number(this.toFixed(2));
};



// WEBPACK FOOTER //
// ./src/services/monkey-patches.js